
import React, { useState, useEffect } from 'react'
import {
  FormGroup,
  ModalBody,
  Col,
  Row,
  Button,
  Nav,
  NavItem,
  NavLink,
  Label,
  Input,
  InputGroup,
  InputGroupText,
  TabContent,
  TabPane,
  Form,
  Badge
} from 'reactstrap'
import BootstrapTable from 'react-bootstrap-table-next'
import cellEditFactory from 'react-bootstrap-table2-editor'
import rest from '../../../lib/rest'
import rotas from '../../../services/rotas'
import useForm from "../../../lib/useForm"
import Loading from 'lib/loading'
import ReactSelect from "../../../components/Form/Select/Select"
import Swal from 'sweetalert2'
import 'sweetalert2/src/sweetalert2.scss'
import withReactContent from 'sweetalert2-react-content'
import ReactDatetime from "react-datetime"
import NumberFormat from 'react-number-format'
import axios from 'axios'
import { cpf, cnpj } from 'cpf-cnpj-validator';
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { ContentState, convertToRaw, EditorState } from 'draft-js'
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import './style.css'

const formSwal = withReactContent(Swal)

const FormCliente = ({ fechaModal, cliente_id, filial_id, setCliente_id }) => {

  const colunasDependente = [
    {
      dataField: 'dependente_id',
      text: 'Código',
      headerStyle: { cursor: 'default' }
    },
    {
      dataField: 'dependente',
      text: 'Dependente',
      align: 'left',
      headerStyle: { cursor: 'default' },
      editable: true,
    },
    {
      dataField: 'excluir',
      text: 'Excluir',
      editable: false,
      formatter: (cellContent, row) => {
        if (row.dependente_id !== '' && row.tipo === 'delete') {
          return ('Excluído')
        } else {
          return (
            <Button
              className="btn-icon btn-neutral"
              color="danger"
              id=""
              size="md"
              type="button"
              onClick={() => deleteDependenteTable(row)}
            >
              <i className="fas fa-times" />
            </Button>
          )
        }
      }
    }
  ]

  const inicialForm = {
    cliente_id: "",
    cliente: "",
    filial_id: filial_id,
    cli_cpf: "",
    cli_rg: "",
    cli_endereco: "",
    cli_numero: "",
    cli_bairro: "",
    cli_cidade: "",
    cli_cep: "",
    cli_uf: "",
    cli_ufSelect: "",
    cli_telefone: "",
    cli_celular: "",
    cli_email: "",
    cli_estado_civil: "",
    cli_estado_civilSelect: "",
    cli_sexo: "",
    cli_sexoSelect: "",
    cli_pai: "",
    cli_conjuge: "",
    cli_mae: "",
    cli_bloqueado: "N",
    cli_inativo: "N",
    cli_especial: "N",
    cli_empresa: "",
    cli_salario: "0.00",
    cli_limite: "0.00",
    cli_chapa: "",
    cli_dia_pagamento: "",
    cli_observacao: "",
    cli_observacao_limpo: "",
    old_cliente: "",
    cli_data_cadastro: "",
    cli_nascimento: "",
    cli_foto: "",
    status_transf: "",
    cli_cartao: "",
    cli_cdi: "N",
    cli_prazo: "",
    responsavel: "",
    cli_senha: "",
    ddd_celular: "",
    avisos_sms: "",
    avisos_email: "",
    dias_aviso: "",
    permitir_crediario: "S",
    integracao_id: "",
    convenio_id: "",
    convenio_idSelect: { id: '', title: 'NENHUM' },
    pessoa: "F",
    senha_clientapp: "",
    email_clientapp: "",
    dependentes: [],
    cli_senha_confirma: "",
    cli_senha_set: 0
  }

  const listaSexo = [
    { "id": "M", "title": "Masculino" },
    { "id": "F", "title": "Feminino" }
  ]

  const listaEstadoCivil = [
    { "id": "S", "title": "Solteiro (a)" },
    { "id": "C", "title": "Casado (a)" },
    { "id": "D", "title": "Divorciado (a)" },
    { "id": "V", "title": "Viúvo (a)" },
    { "id": "U", "title": "União estável" }
  ]

  const listaEstados = [
    { id: "AC", title: "Acre" },
    { id: "AL", title: "Alagoas" },
    { id: "AM", title: "Amazonas" },
    { id: "AP", title: "Amapá" },
    { id: "BA", title: "Bahia" },
    { id: "CA", title: "Ceará" },
    { id: "DF", title: "Distrito Federal" },
    { id: "ES", title: "Espírito Santo" },
    { id: "GO", title: "Goiás" },
    { id: "MA", title: "Maranhão" },
    { id: "MT", title: "Mato Grosso" },
    { id: "MS", title: "Mato Grosso do Sul" },
    { id: "MG", title: "Minas Gerais" },
    { id: "PA", title: "Pará" },
    { id: "PB", title: "Paraíba" },
    { id: "PR", title: "Paraná" },
    { id: "PE", title: "Pernambuco" },
    { id: "PI", title: "Piauí" },
    { id: "RJ", title: "Rio de Janeiro" },
    { id: "RN", title: "Rio Grande do Norte" },
    { id: "RO", title: "Rondônia" },
    { id: "RS", title: "Rio Grande do Sul" },
    { id: "RR", title: "Roraima" },
    { id: "SC", title: "Santa Catarina" },
    { id: "SE", title: "Sergipe" },
    { id: "SP", title: "São Paulo" },
    { id: "TO", title: "Tocantins" }
  ]

  const [form, onChange, setForm, onChangeSelect, onChangeDate] = useForm(inicialForm)
  const [loading, setLoading] = useState(true)
  const [activeTab, setActiveTab] = useState('1')
  const [listaConvenio, setListaConvenio] = useState([])
  const [showSenha, setShowSenha] = useState(false)
  const [showSenhaConfirma, setShowSenhaConfirma] = useState(false)
  const [senhaModificada, setSenhaModificada] = useState(false)
  const [addDependente, setAddDependente] = useState('')
  const [erro, setErro] = useState(false)
  const [tipoDoc_cpf, settipoDoc_cpf] = useState('d-block')
  const [tipoDoc_cnpj, settipoDoc_cnpj] = useState('d-none')
  const [cliObs,setCliObs] = useState(EditorState.createEmpty());
  const [limpandoSenha, setLimpandoSenha] = useState(false);

  const buscaCep = (e) => {
    let cep = e.target.value.replace(/\D/g, '')
    try {
      const retorno = axios.get("https://viacep.com.br/ws/" + cep + "/json/")
      retorno.then(ret => {
        let local = ret.data
        setLoading(true)
        if (!("erro" in ret)) {
          let dados = form
          dados.cli_cidade    = local.localidade
          dados.cli_uf        = local.uf
          dados.cli_endereco  = local.logradouro
          dados.cli_bairro    = local.bairro

          const conv_uf       = listaEstados.filter((item) => item.id === local.uf)
          dados.cli_ufSelect  = conv_uf[0]

          setForm(dados)
        }
        setLoading(false)
      })
    } catch (err) {
      console.log(err)
    }
  }

  const listaConvenios = () => {
    let lista = [{ id: '', title: 'NENHUM' }]

    try {
      const retorno = rest.get(rotas.convenios)
      retorno.then(ret => {
        
        if (ret !== '' && ret.success === 'S' && ret.lista !== '') {
          for (let i = 0; i < ret.lista.length; i++) {
            lista[i + 1] = { "id": ret.lista[i].convenio_id, "title": ret.lista[i].convenio }
          }
          setListaConvenio(lista)
        }
      })
      return (lista)
    } catch (err) {
      console.log(err)
      setErro(true)
    }
  }

  const editCliente = (cliente_id) => {
    try {
      const retorno = rest.get(rotas.clientes + '/cliente.php?id=' + cliente_id)
      retorno.then(ret => {
        if (ret !== '' && ret.success && ret.success === 'S' && ret.lista !== '') {

          if (ret.lista[0].dependentes.erro) {
            ret.lista[0].dependentes = []
          }

          const cli_sexoSelect        = listaSexo.filter((item) => item.id === ret.lista[0].cli_sexo)
          ret.lista[0].cli_sexoSelect = cli_sexoSelect[0]

          const cli_estado_civilSelect        = listaEstadoCivil.filter((item) => item.id === ret.lista[0].cli_estado_civil)
          ret.lista[0].cli_estado_civilSelect = cli_estado_civilSelect[0]

          ret.lista[0].convenio_idSelect = { id: ret.lista[0].convenio_id, title: ret.lista[0].convenio }

          const cli_uf              = listaEstados.filter((item) => item.id === ret.lista[0].cli_uf)
          ret.lista[0].cli_ufSelect = cli_uf[0]

          if (ret.lista[0].pessoa == 'J') {
            settipoDoc_cpf('d-none')
            settipoDoc_cnpj('d-block')
          } else {
            settipoDoc_cpf('d-block')
            settipoDoc_cnpj('d-none')
          }

          ret.lista[0].cli_observacao = trataObservacao(ret.lista[0].cli_observacao)

          setSenhaModificada(false)
          setForm(ret.lista[0])
          setLoading(false)
        } else {
          const msg = (ret && ret.msg) ? ret.msg : 'Erro ao carregar dados do cliente'
          Swal.fire({ icon: 'error', title: 'Erro', text: msg })
          fechaModal()
        }
      })
    } catch (err) {
      console.log(err)
      setErro(true)
    }
  }

  const clik_pessoa = (e) => {
    var check = (e.target.value)
    if (check === "F") {
      settipoDoc_cpf('d-block')
      settipoDoc_cnpj('d-none')
    } else {
      settipoDoc_cpf('d-none')
      settipoDoc_cnpj('d-block')
    }
  }

  const rowStyleDependente = (row, rowIndex) => {
    const style = {};
    
    if (row.dependente_id === '') {
      style.backgroundColor = '#a1f39e';
      style.color = 'black';
    } else if (row.dependente_id !== '' && row.tipo === 'delete') {
      style.backgroundColor = '#f44336';
      style.color = 'white';
    }
    return style;
  };

  const addDependenteTable = () => {
    let array = form.dependentes

    if (addDependente !== '') {
      array.push({ "cliente_id": cliente_id, "dependente": addDependente, "dependente_id": "", "tipo": "add" })
      setAddDependente("")
    }

    form.dependentes = array
  }

  const deleteDependenteTable = (dependente) => {
    setAddDependente(dependente.dependente)

    if (dependente.dependente_id === '') {
      let array         = form.dependentes
      const newArray    = array.filter((item) => item.dependente !== dependente.dependente)
      form.dependentes  = newArray

    } else {
      dependente.tipo = 'delete'
      dependente.excluir = 'delete'
    }
  }

  const editaDependente = (type, { data, cellEdit: { rowId, dataField, newValue } }) => {
    let array = form.dependentes

    if (newValue !== '') {
      array.map(item => (item.dependente_id === rowId ? { ...item, newValue } : item))
    }

    form.dependentes = array
  }

  const editaDependenteTabela = (row) => {
    let dependente    = row.dependente,
        dependente_id = row.dependente_id

    row.tipo  = 'update'
    let array = form.dependentes

    if (dependente !== '') {
      array.map(item => (item.dependente_id === dependente_id ? { ...item, row } : item))
    }
    form.dependentes = array
  }

  const intervalo = e => {
    let min = 0,
        max = 31

    let value       = e.target.value.replace(/[^0-9|.|,]/g, '')
    e.target.value  = value

    if (e.target.name === 'cli_prazo') {
      max = 365
    }

    value               = Math.max(min, Math.min(max, Number(value)))
    e.target.value      = value
    form[e.target.name] = value
  };

  const trataObservacao = (valor) => {
    if (valor.substr(' | ')) {
      valor = valor.replace(/[|]/g, '\n');
    }
    return (valor);
  }

  const validaCpfCnpj = () => {
    if (form.pessoa === 'F') {
      if (form.cli_cpf !== '') {
        if (!cpf.isValid(form.cli_cpf)) {
          return true
        }
      }
    } else {
      if (form.cli_cpf !== '') {
        if (!cnpj.isValid(form.cli_cpf)) {
          return true
        }
      }
    }
    return false
  }

  useEffect(() => {
    listaConvenios()
    if (cliente_id !== '') {
      editCliente(cliente_id)
    } else {
      setForm(inicialForm)
      setLoading(false)
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(()=>{
    obs2obj();
  },[form.cli_observacao]) // eslint-disable-line react-hooks/exhaustive-deps

  const editaObs = (valor) => {
    setCliObs(valor);
  }

  const onChangeSenha = (field) => (e) => {
    setSenhaModificada(true)
    onChange(field)(e)
  }

  const validaSenha = () => {
    if (!senhaModificada) return false
    if (form.cli_senha !== form.cli_senha_confirma) return true
    return false
  }

  const limparSenhaAtual = async () => {
    if (!form.cliente_id) return;

    formSwal.queue([{
      title: 'Remover senha?',
      confirmButtonText: 'Sim, remover',
      showCancelButton: true,
      text: 'Isso apagará a senha atual deste cliente.',
      showLoaderOnConfirm: true,
      cancelButtonColor: '#d33',

      preConfirm: () => {

        try {
          setLimpandoSenha(true);

          const url   = rotas.clientes + 'limparSenhaCliente.php'
          const data  = { cliente_id: form.cliente_id }

          return rest.post(url, data)
            .then(ret => {
              if ((ret.success) && (ret.success === 'S')) {
                setForm(prev => ({
                  ...prev,
                  cli_senha_set: 0,
                  cli_senha: '',
                  cli_senha_confirma: ''
                }));

                formSwal.fire('Sucesso!', ret.msg, 'success')
              } else {
                formSwal.fire('Erro!', ret.msg, 'error')
              }
            })
        } catch (e) {
          Swal.fire('Erro', 'Falha de comunicação com o servidor.', 'error');
        } finally {
          setLimpandoSenha(false);
        }
      }
    }])
  }

  //SUBMIT
  const handleSubmit = (evt) => {
    evt.preventDefault()

    form.cli_observacao = obj2obs();

    if (validaCpfCnpj()) {
      let tipo = (form.pessoa === 'F') ? 'CPF' : 'CNPJ'

      Swal.fire('Atenção', 'Por favor digite um ' + tipo + ' válido!');

      return false
    }

    if (validaSenha()) {
      Swal.fire('Atenção', 'Senha e confirmação não conferem!');
      return false;
    }
      
    formSwal.queue([{
      title: 'Deseja salvar ?',
      confirmButtonText: 'Salvar',
      showCancelButton: true,
      text: 'Essas informações serão salvas no banco',
      showLoaderOnConfirm: true,
      cancelButtonColor: '#d33',
      preConfirm: () => {
        const url = rotas.clientes + 'gravar.php'
        const dados = senhaModificada
          ? form
          : { ...form, cli_senha: '', cli_senha_confirma: '' }

        if (cliente_id !== '') {
          return rest.post(url, dados)
            .then(ret => {
              if ((ret.success) && (ret.success === 'S')) {
                setSenhaModificada(false)
                editCliente(cliente_id)
                formSwal.fire('Salvo!', ret.msg, 'success')
              } else {
                formSwal.fire('Erro!', ret.msg, 'error')
              }
            })
        } else {
          return rest.put(url, dados)
            .then(ret => {
              if ((ret.success) && (ret.success == 'S')) {
                setSenhaModificada(false)
                setCliente_id(ret.cliente_id)
                editCliente(ret.cliente_id)

                formSwal.fire('Salvo!', ret.msg, 'success')
              } else {
                formSwal.fire('Erro!', ret.msg, 'error')
              }
            })
        }
      }
    }])
  }

  const obs2obj = () =>{
    const blocksFromHtml                = htmlToDraft(form.cli_observacao);
    const { contentBlocks, entityMap }  = blocksFromHtml;
    const contentState                  = ContentState.createFromBlockArray(contentBlocks, entityMap);
    const novoObs                       = EditorState.createWithContent(contentState);
    
    setCliObs(novoObs);
  }

  const obj2obs = () =>{

    let textoLimpo    = '',
        contentState  = cliObs.getCurrentContent()

    contentState.getBlockMap().forEach(block => {
      const blockText = block.getText();

      if(blockText !== ''){
        textoLimpo += blockText+'. '
      }
    })
    
    form.cli_observacao_limpo = textoLimpo

    return(draftToHtml(convertToRaw(cliObs.getCurrentContent())))
  }

  if (loading) {
    return (
      <ModalBody className="loadingBody">
        <Loading tipo='componente' />
      </ModalBody>
    )
  } else if (erro) {
    return (
      <FormGroup className="formCadastro">        
        <ModalBody className="pb-0">
          <Col className="text-center">
            <Button className="mb-0" color="default" size="sm" onClick={() => fechaModal()}>Fechar</Button>
          </Col>
        </ModalBody>
      </FormGroup>
    )
  } else {
    return (
      <FormGroup className="formCadastro">
        <ModalBody className="pb-0">
          <Nav pills className="nav-pills-default justify-content-center mb-3">
            <NavItem>
              <NavLink
                className = {activeTab === '1' ? 'active' : ''}
                onClick   = {() => setActiveTab('1')}
              >
                Dados Pessoais
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                className = {activeTab === '2' ? 'active' : ''}
                onClick   = {() => setActiveTab('2')}
              >
                Endereço
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                className = {activeTab === '3' ? 'active' : ''}
                onClick   = {() => setActiveTab('3')}
              >
                Outros Dados
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                className = {activeTab === '4' ? 'active' : ''}
                onClick   = {() => setActiveTab('4')}
              >
                Dependentes
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                className = {activeTab === '5' ? 'active' : ''}
                onClick   = {() => setActiveTab('5')}
              >
                Observações
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                className = {activeTab === '6' ? 'active' : ''}
                onClick   = {() => setActiveTab('6')}
              >
                Senha
              </NavLink>
            </NavItem>
          </Nav>

          <hr />
          <Form onSubmit={handleSubmit}>
            {/* DADOS PESSOAIS */}
            <TabContent activeTab={activeTab}>
              <TabPane tabId="1">
                <Row>
                  <Col md="3">
                    <div className="card-2">
                      <FormGroup className="mb-0">
                        <div className="form-check-radio">
                          <Label className="form-check-label">
                            <Input
                              id        = "fisica"
                              name      = "pessoa"
                              type      = "radio"
                              value     = "F"
                              checked   = {form.pessoa === 'F' ? true : false}
                              onClick   = {clik_pessoa}
                              onChange  = {onChange('pessoa')}
                            />
                            Pessoa Fisica
                            <span className="form-check-sign"></span>
                          </Label>
                        </div>

                        <div className="form-check-radio mb-0">
                          <Label className="form-check-label">
                            <Input
                              id        = "juridica"
                              name      = "pessoa"
                              type      = "radio"
                              value     = "J"
                              checked   = {form.pessoa === 'J' ? true : false}
                              onClick   = {clik_pessoa}
                              onChange  = {onChange('pessoa')}
                            />
                            Pessoa Jurídica
                            <span className="form-check-sign"></span>
                          </Label>
                        </div>
                      </FormGroup>
                    </div>
                  </Col>

                  <Col md="9" className="mt-3">
                    <div className="card-2">
                      <span className="tag-card-div">Opções</span>
                      <FormGroup check inline className="mb-0">
                        <Label check>
                          <Input
                            id        = "crediario"
                            type      = "checkbox"
                            onChange  = {onChange('permitir_crediario')}
                            checked   = {form.permitir_crediario === 'S' ? true : false}
                          />
                          <span className="form-check-sign" />Permitir vendas no crediário
                        </Label>
                      </FormGroup>

                      <FormGroup check inline className="mb-0">
                        <Label check>
                          <Input
                            id        = "sms"
                            type      = "checkbox"
                            onChange  = {onChange('avisos_sms')}
                            checked   = {form.avisos_sms === 'S' ? true : false}
                          />
                          <span className="form-check-sign" />Receber informações sobre vencimentos por sms
                        </Label>
                      </FormGroup>
                    </div>
                  </Col>
                </Row>

                <Row>

                  <Col md='2'>
                    <FormGroup>
                      <Label for="cliente_id">código</Label>
                      <Input
                        disabled
                        id        = "cliente_id"
                        name      = "cliente_id"
                        value     = {form.cliente_id}
                        onChange  = {onChange('cliente_id')}
                      />
                    </FormGroup>
                  </Col>

                  <Col md='6'>
                    <FormGroup>
                      <Label for="nome">Nome</Label>
                      <Input
                        id        = "nome"
                        name      = "nome"
                        maxLength = '50'
                        value     = {form.cliente}
                        onChange  = {onChange('cliente')}
                      />
                    </FormGroup>
                  </Col>

                  <Col md='2'>
                    <FormGroup>
                      <Label for="cartao">Nº Cartão</Label>
                      <Input
                        id        = "cartao"
                        name      = "cartao"
                        type      = "number"
                        maxLength = '16'
                        value     = {form.cli_cartao}
                        onChange  = {onChange('cli_cartao')}
                      />
                    </FormGroup>
                  </Col>

                  <Col md='2'>
                    <FormGroup>
                      <Label for="cadastro">Data cadastro</Label>
                      <Input
                        disabled
                        id        = "cadastro"
                        name      = "cadastro"
                        className = {'disabledCampo'}
                        value     = {form.cli_data_cadastro}
                        onChange  = {onChange('cli_data_cadastro')}
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col md='4'>
                    <FormGroup className={tipoDoc_cpf}>
                      <Label for="cpf">CPF</Label>
                      <NumberFormat
                        id          = "cpf"
                        name        = "cpf"
                        type        = "text"
                        className   = {"form-control"}
                        placeholder = '000.000.000-00'
                        format      = {"###.###.###-##"}
                        value       = {form.cli_cpf}
                        onChange    = {onChange('cli_cpf')}
                      />
                    </FormGroup>

                    <FormGroup className={tipoDoc_cnpj}>
                      <Label for="cpf">CNPJ</Label>
                      <NumberFormat
                        id          = "cnpj"
                        name        = "cnpj"
                        type        = "text"
                        className   = {"form-control"}
                        placeholder = '00.000.000/0000-00'
                        format      = {"##.###.###/####-##"}
                        value       = {form.cli_cpf}
                        onChange    = {onChange('cli_cpf')}
                      />
                    </FormGroup>
                  </Col>

                  <Col md='4'>
                    <FormGroup>
                      <Label for="rg">RG</Label>
                      <Input
                        id        = "rg"
                        name      = "rg"
                        maxLength = '10'
                        value     = {form.cli_rg}
                        onChange  = {onChange('cli_rg')}
                      />
                    </FormGroup>
                  </Col>

                  <Col md='4'>
                    <FormGroup>
                      <Label for="nascimento">Data de Nascimento</Label>
                      <ReactDatetime
                        dateFormat
                        id          = "nascimento"
                        name        = "nascimento"
                        value       = {form.cli_nascimento}
                        onChange    = {onChangeDate('cli_nascimento')}
                        timeFormat  = {false}
                        inputProps  = {{
                          className:    "form-control",
                          placeholder:  'clique para selecionar'
                        }}
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col md='3'>
                    <FormGroup>
                      <Label for="telefone">Telefone</Label>
                      <NumberFormat
                        id        = "telefone"
                        name      = "telefone"
                        className = "form-control"
                        format    = "(##) ##### ####"
                        mask      = "_"
                        value     = {form.cli_telefone}
                        onChange  = {onChange('cli_telefone')}
                      />
                    </FormGroup>
                  </Col>

                  <Col md='3'>
                    <FormGroup>
                      <Label for="celular">Celular</Label>
                      <NumberFormat
                        id        = "celular"
                        name      = "celular"
                        type      = "text"
                        className = "form-control"
                        mask      = "_"
                        format    = "(##) ##### ####"
                        value     = {form.cli_celular}
                        onChange  = {onChange('cli_celular')}
                      />
                    </FormGroup>
                  </Col>

                  <Col md='6'>
                    <FormGroup>
                      <Label for="email">E-mail</Label>
                      <Input
                        id          = "email"
                        name        = "email"
                        type        = "email"
                        placeholder = "exemplo email@email.com.br"
                        maxLength   = {150}
                        value       = {form.cli_email}
                        onChange    = {onChange('cli_email')}
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </TabPane>
            </TabContent>

            {/* ENDEREÇO */}
            <TabContent activeTab={activeTab}>
              <TabPane tabId="2">
                <Row>
                  <Col md='2'>
                    <FormGroup>
                      <Label for="cep">CEP</Label>
                      <NumberFormat
                        id        = "cep"
                        name      = "cep"
                        type      = "text"
                        className = "form-control"
                        format    = "#####-###"
                        mask      = "_"
                        value     = {form.cli_cep}
                        onChange  = {onChange('cli_cep')}
                        onBlur    = {buscaCep}
                      />
                    </FormGroup>
                  </Col>

                  <Col md='8'>
                    <FormGroup>
                      <Label for="endereco">Endereço</Label>
                      <Input
                        id        = "endereco"
                        name      = "endereco"
                        maxLength = {100}
                        value     = {form.cli_endereco}
                        onChange  = {onChange('cli_endereco')}
                      />
                    </FormGroup>
                  </Col>

                  <Col md='2'>
                    <FormGroup>
                      <Label for="endereco">Número</Label>
                      <Input
                        id        = "endereco"
                        name      = "endereco"
                        maxLength = {10}
                        value     = {form.cli_numero}
                        onChange  = {onChange('cli_numero')}
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col md='6'>
                    <FormGroup>
                      <Label for="referencia">Complemento</Label>
                      <Input
                        id        = "complemento"
                        name      = "complemento"
                        maxLength = {50}
                        value     = {form.cli_complemento}
                        onChange  = {onChange('cli_complemento')}
                      />
                    </FormGroup>
                  </Col>
                  <Col md='6'>
                    <FormGroup>
                      <Label for="referencia">Referência</Label>
                      <Input
                        id        = "referencia"
                        name      = "referencia"
                        maxLength = {50}
                        value     = {form.cli_referencia}
                        onChange  = {onChange('cli_referencia')}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md='4'>
                    <FormGroup>
                      <Label for="bairro">Bairro</Label>
                      <Input
                        id        = "bairro"
                        name      = "bairro"
                        maxLength = {100}
                        value     = {form.cli_bairro}
                        onChange  = {onChange('cli_bairro')}
                      />
                    </FormGroup>
                  </Col>

                  <Col md='5'>
                    <FormGroup>
                      <Label for="bairro">Cidade</Label>
                      <Input
                        id        = "cidade"
                        name      = "cidade"
                        maxLength = {100}
                        value     = {form.cli_cidade}
                        onChange  = {onChange('cli_cidade')}
                      />
                    </FormGroup>
                  </Col>

                  <Col md='3'>
                    <FormGroup>
                      <Label for="estado">Estado</Label>
                      <ReactSelect
                        id            = "estado"
                        name          = "estado"
                        placeholder   = "Selecione"
                        options       = {listaEstados}
                        defaultValue  = {form.cli_ufSelect}
                        onChange      = {onChangeSelect('cli_ufSelect')}
                        onClick       = {form.cli_ufSelect ? form.cli_uf = form.cli_ufSelect.id : ''}
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </TabPane>
            </TabContent>

            {/* OUTROS DADOS */}
            <TabContent activeTab={activeTab}>
              <TabPane tabId="3">
                <Row>
                  <Col md="2">
                    <FormGroup>
                      <Label for="sexo">Sexo</Label>
                      <ReactSelect
                        id            = "sexo"
                        name          = "sexo"
                        placeholder   = "Selecione"
                        options       = {listaSexo}
                        defaultValue  = {form.cli_sexoSelect}
                        onChange      = {onChangeSelect('cli_sexoSelect')}
                        onClick       = {form.cli_sexoSelect ? form.cli_sexo = form.cli_sexoSelect.id : ''}
                      >
                      </ReactSelect>
                    </FormGroup>
                  </Col>

                  <Col md="2">
                    <FormGroup>
                      <Label for="civil">Estado Civil</Label>
                      <ReactSelect
                        id            = "civil"
                        name          = "civil"
                        placeholder   = "Selecione"
                        options       = {listaEstadoCivil}
                        defaultValue  = {form.cli_estado_civilSelect}
                        onChange      = {onChangeSelect('cli_estado_civilSelect')}
                        onClick       = {form.cli_estado_civilSelect ? form.cli_estado_civil = form.cli_estado_civilSelect.id : ''}

                      >
                      </ReactSelect>
                    </FormGroup>
                  </Col>

                  <Col md="8">
                    <div className="card-2">
                      <span className="tag-card-div">Status</span>
                      <FormGroup check inline className="mb-0">
                        <Label check>
                          <Input
                            id        = "especial"
                            type      = "checkbox"
                            checked   = {form.cli_especial === 'S' ? true : false}
                            onChange  = {onChange('cli_especial')}
                          />
                          <span className="form-check-sign" />Especial
                        </Label>
                      </FormGroup>

                      <FormGroup check inline className="mb-0">
                        <Label check>
                          <Input
                            id        = "bloqueado"
                            type      = "checkbox"
                            checked   = {form.cli_bloqueado === 'S' ? true : false}
                            onChange  = {onChange('cli_bloqueado')}
                          />
                          <span className="form-check-sign" />Bloqueado
                        </Label>
                      </FormGroup>

                      <FormGroup check inline className="mb-0">
                        <Label check>
                          <Input
                            id        = "inativo"
                            type      = "checkbox"
                            checked   = {form.cli_inativo === 'S' ? true : false}
                            onChange  = {onChange('cli_inativo')}
                          />
                          <span className="form-check-sign" />Inativo
                        </Label>
                      </FormGroup>

                      <FormGroup check inline className="mb-0">
                        <Label check>
                          <Input
                            id        = "cdi"
                            type      = "checkbox"
                            checked   = {form.cli_cdi === 'S' ? true : false}
                            onChange  = {onChange('cli_cdi')}
                          />
                          <span className="form-check-sign" />Incluso CDI
                        </Label>
                      </FormGroup>
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col md="4">
                    <FormGroup>
                      <Label for="convenio">Convênio</Label>
                      <ReactSelect
                        id            = "convenio"
                        name          = "convenio"
                        placeholder   = "Selecione"
                        options       = {listaConvenio}
                        defaultValue  = {form.convenio_idSelect}
                        onChange      = {onChangeSelect('convenio_idSelect')}
                        onClick       = {form.convenio_idSelect ? form.convenio_id = form.convenio_idSelect.id : ''}
                      >
                      </ReactSelect>
                    </FormGroup>
                  </Col>

                  <Col md='6'>
                    <FormGroup>
                      <Label for="empresa">Empresa</Label>
                      <Input
                        id        = "empresa"
                        name      = "empresa"
                        maxLength = {30}
                        value     = {form.cli_empresa}
                        onChange  = {onChange('cli_empresa')}
                      />
                    </FormGroup>
                  </Col>

                  <Col md='2'>
                    <FormGroup>
                      <Label for="matricula">Matrícula</Label>
                      <Input
                        id        = "matricula"
                        name      = "matricula"
                        type      = "text"
                        maxLength = {12}
                        value     = {form.cli_chapa}
                        onChange  = {onChange('cli_chapa')}
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col md='4'>
                    <FormGroup>
                      <Label for="conjuge">Cônjuge</Label>
                      <Input
                        id        = "conjuge"
                        name      = "conjuge"
                        value     = {form.cli_conjuge}
                        onChange  = {onChange('cli_conjuge')}
                        maxLength = {50}
                      />
                    </FormGroup>
                  </Col>

                  <Col md='4'>
                    <FormGroup>
                      <Label for="pai">Pai</Label>
                      <Input
                        id        = "pai"
                        name      = "pai"
                        value     = {form.cli_pai}
                        onChange  = {onChange('cli_pai')}
                        maxLength = {50}
                      />
                    </FormGroup>
                  </Col>

                  <Col md='4'>
                    <FormGroup>
                      <Label for="mae">Mãe</Label>
                      <Input
                        id        = "mae"
                        name      = "mae"
                        value     = {form.cli_mae}
                        onChange  = {onChange('cli_mae')}
                        maxLength = {50}
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col md='3'>
                    <FormGroup>
                      <Label for="limite">Limite</Label>
                      <NumberFormat
                        fixedDecimalScale
                        id                = "limite"
                        name              = "limite"
                        className         = {"form-control"}
                        placeholder       = "0.00"
                        maxLength         = {20}
                        decimalScale      = {2}
                        allowNegative     = {false}
                        prefix            = {"R$ "}
                        decimalSeparator  = {','}
                        value             = {form.cli_limite}
                        onChange          = {onChange('cli_limite')}
                      />
                    </FormGroup>
                  </Col>

                  <Col md='3'>
                    <FormGroup>
                      <Label for="salario">Salário</Label>
                      <NumberFormat
                        fixedDecimalScale
                        id                = "salario"
                        name              = "salario"
                        placeholder       = "0.00"
                        maxLength         = {20}
                        decimalScale      = {2}
                        allowNegative     = {false}
                        className         = {"form-control"}
                        prefix            = {"R$ "}
                        decimalSeparator  = {','}
                        value             = {form.cli_salario}
                        onChange          = {onChange('cli_salario')}
                      />
                    </FormGroup>
                  </Col>

                  <Col md='3'>
                    <FormGroup>
                      <Label for="pgto">Dia Pgto</Label>
                      <Input
                        id        = "cli_dia_pagamento"
                        name      = "cli_dia_pagamento"
                        type      = "number"
                        maxLength = {10}
                        value     = {form.cli_dia_pagamento}
                        onChange  = {onChange('cli_dia_pagamento')}
                        onBlur    = {intervalo}
                      />
                    </FormGroup>
                  </Col>

                  <Col md='3'>
                    <FormGroup>
                      <Label for="prazo">Prazo</Label>
                      <Input
                        id        = "cli_prazo"
                        name      = "cli_prazo"
                        type      = "number"
                        value     = {form.cli_prazo}
                        onChange  = {onChange('cli_prazo')}
                        onBlur    = {intervalo}
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </TabPane>
            </TabContent>

            {/* DEPENDENTES */}
            <TabContent activeTab={activeTab}>
              <TabPane tabId="4">
                <Row>
                  <Col md="4">
                    <FormGroup>
                      <Label for="dependente">Nome</Label>
                      <Input
                        id        = "dependenteInput"
                        name      = "dependente"
                        maxLength = {50}
                        value     = {addDependente}
                        onChange  = {e => setAddDependente(e.target.value)}
                      />
                    </FormGroup>

                    <Button
                      id        = "addDependente"
                      className = "float-right mt-0"
                      size      = "sm"
                      color     = "success"
                      onClick   = {() => addDependenteTable()}
                    >
                      Adicionar
                    </Button>
                  </Col>

                  <Col md="8">

                    <BootstrapTable
                      striped
                      outline
                      keyField          = "dependente_id"
                      data              = {form.dependentes}
                      columns           = {colunasDependente}
                      noDataIndication  = "Nenhum registro encontrado"
                      rowStyle          = {rowStyleDependente}
                      cellEdit          = {cellEditFactory({ 
                        mode: 'dbclick',
                        afterSaveCell: (oldValue, newValue, row, column) => editaDependenteTabela(row)
                      })}
                      onTableChange     = {(type, { data, cellEdit: { rowId, dataField, newValue } }) => editaDependente(type,    { data, cellEdit: { rowId, dataField, newValue } })}
                    />

                  </Col>
                </Row>
              </TabPane>
            </TabContent>

            {/* OBSERVAÇÕES */}
            <TabContent activeTab={activeTab}>
              <TabPane tabId="5">
                <FormGroup>
                  <div style={{border:"1px solid",borderColor:"#cccccc", padding:"10px"}}>
                    <Editor
                      editorState         = {cliObs}
                      wrapperClassName    = "demo-wrapper"
                      editorClassName     = "demo-editor"
                      onEditorStateChange = {editaObs}
                      placeholder         = {"Digite aqui a observação"}
                      toolbar             = {{ options : ['inline', 'blockType', 'fontSize', 'fontFamily', 'list', 'textAlign', 'colorPicker', 'link', 'emoji', 'history'] }}
                    />               
                  </div>
                </FormGroup>
              </TabPane>
            </TabContent>

            {/* SENHA */}
            <TabContent activeTab={activeTab}>
              <TabPane tabId="6">

                <Row className="justify-content-md-center text-center">
                  <Col md="4" className="mt-1">
                    {form.cli_senha_set ? (
                      <span
                        role="button"
                        tabIndex={0}
                        onClick={limparSenhaAtual}
                        onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && limparSenhaAtual()}
                        className="badge-clickable"
                        title="Clique para remover a senha"
                      >
                        <Badge color="success" pill>
                          {limpandoSenha ? 'Removendo.senha..' : 'SENHA ATIVA'}
                        </Badge>
                      </span>
                    ) : (
                      <Badge color="info" pill>Nenhuma senha definida</Badge>
                    )}
                  </Col>
                </Row>
                
                <Row className="justify-content-md-center mt-3">
                  <Col md='4'>
                    <FormGroup className="m-1">
                      <Label for="cli_senha">Senha</Label>
                      <InputGroup>
                        <Input
                          id             = "cli_senha"
                          name           = "cli_senha"
                          type           = {showSenha ? "text" : "password"}
                          autoComplete   = "new-password"
                          placeholder    = "Deixe em branco para não alterar"
                          maxLength      = "32"
                          value          = {form.cli_senha}
                          onChange       = {onChangeSenha('cli_senha')}
                        />
                        <InputGroupText
                          style={{ cursor: 'pointer' }}
                          onClick={() => setShowSenha(v => !v)}
                        >
                          <i className={`fa ${showSenha ? 'fa-eye-slash' : 'fa-eye'}`} />
                        </InputGroupText>
                      </InputGroup>
                    </FormGroup>
                  </Col>
                </Row>

                <Row className="justify-content-md-center mb-3">
                  <Col md='4'>
                    <FormGroup className="m-1">
                      <Label for="cli_senha_confirma">Confirmação de Senha</Label>
                      <InputGroup>
                        <Input
                          id             = "cli_senha_confirma"
                          name           = "cli_senha_confirma"
                          type           = {showSenhaConfirma ? "text" : "password"}
                          autoComplete   = "new-password"
                          placeholder    = "Confirme sua nova senha"
                          maxLength      = "32"
                          value          = {form.cli_senha_confirma}
                          onChange       = {onChangeSenha('cli_senha_confirma')}
                        />
                        <InputGroupText
                          style={{ cursor: 'pointer' }}
                          onClick={() => setShowSenhaConfirma(v => !v)}
                        >
                          <i className={`fa ${showSenhaConfirma ? 'fa-eye-slash' : 'fa-eye'}`} />
                        </InputGroupText>
                      </InputGroup>
                    </FormGroup>
                  </Col>
                </Row>

              </TabPane>
            </TabContent>


            <Col className="text-center">
              <Button type="submit" className="mb-0" color="success" size="sm" >Salvar</Button>
              <Button className="mb-0" color="default" size="sm" onClick={() => fechaModal()}>Fechar</Button>
            </Col>
          </Form>
        </ModalBody>
      </FormGroup>
    )
  }
}

export default FormCliente
